// Chargement des fichiers générés avec cache (une seule requête par URL, partagée entre humains).

const jsonCache = new Map<string, Promise<unknown>>();
const binCache = new Map<string, Promise<ArrayBuffer>>();

async function get(url: string): Promise<Response> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`human: ${res.status} ${res.statusText} pour ${url}`);
  return res;
}

export function fetchJson<T>(url: string): Promise<T> {
  let p = jsonCache.get(url);
  if (!p) {
    p = get(url).then((r) => r.json());
    p.catch(() => jsonCache.delete(url));
    jsonCache.set(url, p);
  }
  return p as Promise<T>;
}

export function fetchBin(url: string): Promise<ArrayBuffer> {
  let p = binCache.get(url);
  if (!p) {
    p = get(url).then((r) => r.arrayBuffer());
    p.catch(() => binCache.delete(url));
    binCache.set(url, p);
  }
  return p;
}

/** Vide le cache (ex. après régénération des assets en dev). */
export function clearAssetCache() {
  jsonCache.clear();
  binCache.clear();
}

/** Résout une URL relative à la racine des assets en URL absolue. */
export function resolveUrl(baseUrl: string, rel: string): string {
  const base = new URL(baseUrl.endsWith('/') ? baseUrl : baseUrl + '/', globalThis.location?.href ?? 'http://localhost/');
  return new URL(rel, base).href;
}
